// extracted by mini-css-extract-plugin
export default {"carouselWrapper":"SignUpStep-module-carouselWrapper-2amQ3","asideWrapper":"SignUpStep-module-asideWrapper-37GI7"};